import Modal from 'components/_parts/atoms/modal';
import Tab from 'components/_parts/atoms/tab';
import { useOuterClick } from 'providers/OutsideClick';
import {
  Dispatch, SetStateAction, useEffect, useMemo, useState,
} from 'react';
import { DataNotification } from '.';
import Content from './content';

function PopUpListNotif({
  dataUnread,
  data,
  show,
  allDataLoaded,
  handleModal,
  fetchData,
  handleRead,
  setData,
  setDataUnread,
}: Readonly<{
  allDataLoaded: {
    unread: {
      allLoaded: boolean;
    };
    read: {
      allLoaded: boolean;
    };
  },
  dataUnread: DataNotification;
  data: DataNotification;
  show: boolean;
  handleModal: Dispatch<{
    type: 'showSeekList' | 'showFullList';
    payload: boolean;
  }>;
  handleRead: (notification_id: string) => Promise<void>;
  setData: Dispatch<SetStateAction<DataNotification>>;
  setDataUnread: Dispatch<SetStateAction<DataNotification>>
  fetchData: ({
    page,
    pageSize,
    is_read,
    ln,
  }: {
    page: string;
    pageSize: string;
    is_read?: boolean;
    ln?: string
  }) => Promise<void>;
}>) {
  const [tab, setTab] = useState(0);
  const [currentPage, setCurrentPage] = useState({
    read: 1,
    unread: 1,
  });
  const handleCloseModal = () => {
    handleModal({
      type: 'showFullList',
      payload: false,
    });
    setTab(0);
    setData([]);
    setDataUnread([]);
    setCurrentPage({
      read: 1,
      unread: 1,
    });
  };
  const useRefOuterModal = useOuterClick(
    (e: MouseEvent) => !['notification_modal', 'view_all_notification'].includes(
      (e.target as HTMLDivElement).id,
    )
      && show
      && handleCloseModal()

    ,
  );

  const tabList = [
    {
      id: 0,
      name: 'Unread',
    },
    {
      id: 1,
      name: 'Read',
    },
  ];
  console.log(currentPage, tab, '<<cpg');

  useEffect(() => {
    const allData = {
      unread: dataUnread,
      read: data,
    };
    if (currentPage[tab === 0 ? 'unread' : 'read'] === 1 && allData[tab === 0 ? 'unread' : 'read'].length === 0) {
      const ln = localStorage.getItem('language') ?? 'id';
      fetchData({
        page: '1', pageSize: '15', is_read: tab === 1, ln,
      }).catch(
        () => {},
      );
    }
  }, [tab, localStorage.getItem('language'), currentPage]);

  const dataContent = useMemo(() => {
    const copyData = [...data];
    const copyDataUnread = [...dataUnread];
    if (tab === 0) return copyDataUnread;
    return copyData;
  }, [data, dataUnread, tab]);
  console.log(dataContent, '<<dt-content');

  return (
    <Modal modal={show} type="notification">
      <div
        id="notification_modal"
        className="w-100 h-100"
        ref={useRefOuterModal}
      >
        <h4 className="title_notification">Notification List</h4>
        <div className="d-flex justify-content-center">
          <Tab data={tabList} tab={tab} setTab={setTab} />
        </div>
        <Content
          allDataLoaded={allDataLoaded}
          setCurrentPage={setCurrentPage}
          data={dataContent}
          handleRead={handleRead}
          fetchData={fetchData}
          currentPage={currentPage}
          currentTab={tab}
          setData={setData}
          setDataUnread={setDataUnread}
        />
      </div>
    </Modal>
  );
}

export default PopUpListNotif;
